module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy4xODg2MSIgY3k9IjcuMTg4NzEiIHI9IjYuNTM4NzEiIHN0cm9rZT0iIzAwMjMyQSIgc3Ryb2tlLXdpZHRoPSIxLjMiLz4KPHBhdGggZD0iTTE3LjY0OTkgMTcuNjUwMUwxMi40MTg5IDEyLjQxOTEiIHN0cm9rZT0iIzAwMjMyQSIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico-svg/Buscar.svg
// module id = Q7LN
// module chunks = 62